import React from "react";
import styles from './Protocol.module.sass';
import Queryable from "../Queryable/Queryable";
import Color from "color";

export interface ProtocolInterface {
  name: string
  longName: string
  abbr: string
  macro: string
  backgroundColor: string
  foregroundColor: string
  fontSize: number
  referenceLink: string
  ports: string[]
  inbound_ports: string
}

interface ProtocolProps {
  protocol: ProtocolInterface
  horizontal: boolean
  height: string
  error: boolean
}

const Protocol: React.FC<ProtocolProps> = ({ protocol, horizontal, height, error }) => {
  const lightBackgroundColor = Color(protocol.backgroundColor).lighten(0.25);

  if (horizontal) {
    return <Queryable
      query={protocol.macro}
      displayIconOnMouseOver={true}
    >
      <a target="_blank" rel="noopener noreferrer" href={protocol.referenceLink}>
        <span
          className={`${styles.base} ${styles.horizontal}`}
          style={{
            color: protocol.foregroundColor,
            background: error ? `repeating-linear-gradient(45deg, ${lightBackgroundColor}, ${lightBackgroundColor} 10px, ${protocol.backgroundColor} 10px, ${protocol.backgroundColor} 20px)` : protocol.backgroundColor,
          }}
          title={protocol.abbr}
        >
          {protocol.longName}
        </span>
      </a>
    </Queryable>
  } else {
    return <Queryable
      query={protocol.macro}
      displayIconOnMouseOver={true}
      flipped={false}
      iconStyle={{ position: 'absolute', bottom: '-12px', left: '16px', zIndex: 1000 }}
      tooltipStyle={{ position: 'absolute', top: '5px', left: '22px', zIndex: 1001 }}
    >
      <span
        className={`${styles.base} ${styles.vertical}`}
        style={{
          height: height,
          color: protocol.foregroundColor,
          fontSize: protocol.fontSize,
          background: error ? `repeating-linear-gradient(45deg, ${lightBackgroundColor}, ${lightBackgroundColor} 10px, ${protocol.backgroundColor} 10px, ${protocol.backgroundColor} 20px)` : protocol.backgroundColor,
        }}
        title={protocol.longName}
      >
        {protocol.abbr}
      </span>
    </Queryable>
  }
};

export default Protocol;
